// extracted by mini-css-extract-plugin
export var card = "_a4-0";
export var expandedCard = "_a4-2";
export var paginated = "_a4-1";